import React from 'react';

export function DashboardSkeleton() {
  return (
    <div className="skeleton-container" aria-busy="true" aria-label="Loading pump telemetry">
      {/* 5 KPI Cards Skeleton */}
      <div className="kpi-grid">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="kpi-card skeleton-kpi">
            <div className="kpi-card-top">
              <div className="skeleton-line skeleton-icon" />
              <div className="skeleton-line skeleton-pill" />
            </div>
            <div className="kpi-copy">
              <div className="skeleton-line skeleton-label" />
              <div className="skeleton-line skeleton-value" />
            </div>
            <div className="skeleton-line skeleton-delta" />
          </div>
        ))}
      </div>

      {/* Primary Grid Skeleton: Health Indicators + Chart */}
      <div className="dashboard-primary-grid">
        <div className="card-panel health-panel">
          <div className="panel-heading">
            <div>
              <div className="skeleton-line skeleton-kicker" />
              <div className="skeleton-line skeleton-title" />
            </div>
            <div className="skeleton-line skeleton-meta" />
          </div>
          <div className="health-grid">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="health-card skeleton-health-card">
                <div className="skeleton-line skeleton-health-icon" />
                <div style={{ width: '100%' }}>
                  <div className="skeleton-line skeleton-health-text" />
                  <div className="skeleton-line skeleton-health-status" />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card-panel chart-panel">
          <div className="panel-heading chart-heading">
            <div>
              <div className="skeleton-line skeleton-kicker" />
              <div className="skeleton-line skeleton-title" />
            </div>
            <div className="skeleton-line skeleton-select" />
          </div>
          <div className="skeleton-chart-surface">
            <div className="skeleton-chart-wave" />
          </div>
        </div>
      </div>

      {/* Diagnostics Panel Skeleton */}
      <div className="card-panel diagnostics-panel">
        <div className="panel-heading">
          <div>
            <div className="skeleton-line skeleton-kicker" />
            <div className="skeleton-line skeleton-title" />
          </div>
          <div className="skeleton-line skeleton-pill" />
        </div>
        <div className="skeleton-line skeleton-diag-box" />
      </div>

      {/* Telemetry Table Skeleton */}
      <div className="card-panel telemetry-panel">
        <div className="panel-heading">
          <div>
            <div className="skeleton-line skeleton-kicker" />
            <div className="skeleton-line skeleton-title" />
          </div>
          <div className="skeleton-line skeleton-pill" />
        </div>
        <div className="skeleton-table-rows">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="skeleton-table-row">
              <div className="skeleton-line" style={{ width: '25%' }} />
              <div className="skeleton-line" style={{ width: '18%' }} />
              <div className="skeleton-line" style={{ width: '18%' }} />
              <div className="skeleton-line" style={{ width: '22%' }} />
              <div className="skeleton-line" style={{ width: '10%' }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DashboardSkeleton;
